<template>
  <PrivacySection title="5. Modalità di Trattamento">
    <p>
      I dati personali sono trattati mediante strumenti informatici e telematici, 
      con logiche strettamente correlate alle finalità indicate e, comunque, in modo 
      da garantire la sicurezza e la riservatezza dei dati stessi.
    </p>
    <p>
      <strong>Importante:</strong> I dati raccolti dall'applicazione mobile (codice fiscale 
      e codice lotteria) vengono memorizzati esclusivamente sul dispositivo dell'utente. 
      Non vengono inviati a server esterni, ad eccezione delle comunicazioni necessarie 
      per accedere al sito governativo della Lotteria degli Scontrini, per le quali 
      non abbiamo accesso ai dati trasmessi.
    </p>
    <p>
      I dati raccolti dal sito web (tramite modulo di contatto) vengono trattati 
      esclusivamente per rispondere alle richieste degli utenti e non vengono condivisi 
      con terze parti, salvo quanto indicato nella sezione "Comunicazione dei Dati".
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'

export default {
  name: 'ProcessingMethodsSection',
  components: {
    PrivacySection
  }
}
</script>

